import React from 'react'
import {Layout, Typography} from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
const {Title} = Typography

export default (props) => {
    const {xs} = useBreakpoint();

    return (
          <Title {...props}>
              {props.children}
          </Title>
    )
}